export const FETCH_INQUIRIES = "inquiry/fetch";
export const ANSWER_INQUIRY = "inquiry/answer";
export const ADD_INQUIRY = "inquiry/add";

